module.exports = __webpack_public_path__ + "static/media/tail_together.79df28ae.jpeg";